import { Subject } from "rxjs";
import { log2 } from "./log2";

const messages = new Subject();
const log = log2("PUB_SUB");
export const SystemMessageTypes = {
    TAB_VISIBILITY_CHANGE: "tab_visibility_change",
    OPEN_CHAT: "open_chat",
    FOCUS_CHAT: "focus_chat",
    OPEN_TEAM_CHAT: "open_team_chat",
    INVOICE_CREATED: "invoice-created",
    CONNECT_SUPPORT_TEAM: "connect-support-team",
    SW_REGISTERED: "sw-registered",
    NOTIFICATION_GRANTED: "notification-granted",
    ACTIVE_CONVERSATION_CHANGED: "active-conversation-changed",
    ACTIVE_CONVERSATION_LOAD_MORE: "active-conversation-load-more",
    TEAM_CONVERSATION_LOAD_MORE: "team-conversation-load-more",
    CB_FOCUS_BLOCK: "cb-focus-block",
    CB_SELECT_BLOCK: "cb-select-block",
    CB_ATTRIBUTE_CHANGED: "cb-attribute-changed",
    CB_SHOW_ATTRIBUTE_MODAL: "cb-show-attribute-modal",
    CB_CHAT_WIDGET_OPEN_STATE_CHANGED: "cb-chat-widget-open-state-changed",
    CB_GET_CUSTOM_ATTRIBUTES: "cb-get-custom-attributes",
    CB_GET_CUSTOM_ATTRIBUTES_RESPONSE: "cb-get-custom-attributes-response",
    CB_BUTTON_CLICK: "cb-button-click",
    START_AGENT_CHAT: "start-agent-chat",
    SETTINGS_PAGE_CHANGED: "settings_page_changed",
    NOTIFICATION_SETTINGS: "notification_settings",
    START_SCRAPE_WEBSITE: "scrape_website",
    ACTIVE_VOICE_ASSISTANT: "active_voice_assistant",
    NOTIFICATION_UPDATED: "notification_updated",
    AUTOMATION_CLOSE_TOOLBAR: "AUTOMATION_CLOSE_TOOLBAR",
};
export const publishMessage = (type, payload) => {
    // log("publishMessage", { type, payload });
    messages.next({
        type,
        payload,
    });
};

export const systemMessageStream = messages.asObservable();

document.addEventListener("visibilitychange", () => {
    publishMessage(SystemMessageTypes.TAB_VISIBILITY_CHANGE, {
        visible: document.visibilityState === "visible",
    });
});

const SYSTEM_PUBSUB = {
    stream: systemMessageStream,
    publish: publishMessage,
    MESSAGE_TYPES: SystemMessageTypes,
};
export default SYSTEM_PUBSUB;
